module.exports = __webpack_public_path__ + "static/media/TenaTurismImg.0be55a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/TenaTurismImg.png
// module id = 455
// module chunks = 0